<script setup>
import { computed, onMounted } from 'vue';
import BaseBubble from './Base.vue';
import AudioChip from 'next/message/chips/Audio.vue';
import { useMessageContext } from '../provider.js';
import { useLoadWithRetry } from 'dashboard/composables/loadWithRetry';
import Icon from 'next/icon/Icon.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const { attachments } = useMessageContext();

const attachment = computed(() => {
  return attachments.value[0];
});

const { isLoaded, hasError, loadWithRetry } = useLoadWithRetry({
  type: 'audio',
});

onMounted(() => {
  if (attachment.value?.dataUrl) {
    loadWithRetry(attachment.value.dataUrl);
  }
});
</script>

<template>
  <BaseBubble class="bg-transparent" data-bubble-name="audio">
    <div
      v-if="hasError"
      class="rounded-xl w-full gap-2 p-3 bg-n-alpha-white flex items-center justify-between border border-n-container shadow-[0px_2px_8px_0px_rgba(94,94,94,0.06)]"
    >
      <div class="flex items-center gap-1.5 text-xs text-n-ruby-11">
        <Icon icon="i-lucide-alert-triangle" class="size-[14px]" />
        <span>{{ t('COMPONENTS.MEDIA.LOADING_FAILED') }}</span>
      </div>
      <button
        type="button"
        class="bg-n-alpha-2 rounded-md size-6 grid place-content-center cursor-pointer hover:bg-n-alpha-3 transition-colors border-0"
        @click="loadWithRetry(attachment.dataUrl)"
      >
        <Icon icon="i-lucide-refresh-ccw" class="text-n-ruby-11 size-4" />
      </button>
    </div>
    <AudioChip
      v-else-if="isLoaded"
      :attachment="attachment"
      class="p-2 text-n-slate-12 skip-context-menu"
    />
  </BaseBubble>
</template>
